import React from "react"
import { motion } from "framer-motion"
import { Box, Spinner } from "@chakra-ui/react"
import { TQR_CODE_CONFIG } from "./utils/config"

const MotionBox = motion.create(Box)

const TQRCodeLoading = ({
  primaryColor,
  size = TQR_CODE_CONFIG.SIZE,
}: {
  primaryColor: string
  size?: number
}) => (
  <MotionBox
    key="loading"
    display="flex"
    justifyContent="center"
    alignItems="center"
    boxSize={size}
  >
    <Spinner
      size="xl"
      color={primaryColor}
      label=""
      aria-label="Loading..."
    />
  </MotionBox>
)

export default TQRCodeLoading
